'use client';
import { CheckboxStyled } from './checkbox.styles';

declare module '@mui/material/Checkbox' {
  interface CheckboxPropsColorOverrides {
    tertiary: true;
  }
}

const Checkbox = CheckboxStyled;

export default Checkbox;
